<template>
  <div v-if="Object.keys(teeshirts).length > 0">
    <v-row>
      <v-col cols="12" md="4" class="pa-2">
        <div class="bordered rounded bg-grey_3 pa-3">
          <div v-for="(value, name, index) in teeshirts" :key="index">
            <div class="d-flex justify-space-between">
              <div class="font-weight-bold">
                {{ name }}
              </div>
              <div class="text-h5 font-weight-bold">
                {{ value }}<span style="font-size:0.9rem;">{{ get_quantity_for_size(name) }}</span>
              </div>
            </div>
            <v-divider style="margin: 5px 0 !important"></v-divider>
          </div>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";

export default {
  components: {},
  data() {
    return {
      teeshirts: {},
      quantity: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    get_quantity_for_size(size) {
      if (this.quantity.length == 0) return "";
      if (this.quantity['quantity_' + size] == undefined) return "";
      return "/" + this.quantity['quantity_' + size];
    }
  },
  async created() {
    let req = await AdminService.getTeeShirts(this.mainStore.module.id);
    if (req) {
      this.teeshirts = req.results;
      this.quantity = req.quantity;
    }
  },
};
</script>

<style lang="scss" scoped></style>